<ion-content>
  <ion-list>
    <ion-item>
      <ion-label>
        <strong>{{ 'i18n.manageUsers.username' | translate }}</strong>
        <ion-text>{{ user?.userName || '-' }}</ion-text>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label>
        <strong>{{ 'i18n.manageUsers.firstName' | translate }}</strong>
        <ion-text>{{ user?.firstName || '-' }}</ion-text>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label>
        <strong>{{ 'i18n.manageUsers.lastName' | translate }}</strong>
        <ion-text>{{ user?.lastName || '-' }}</ion-text>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-label>
        <strong>{{ 'i18n.manageUsers.email' | translate }}</strong>
        <ion-text>{{ user?.email || '-' }}</ion-text>
      </ion-label>
    </ion-item>
    <ion-item lines="none">
      <ion-label>
        <strong>{{ 'i18n.manageUsers.lastLogin' | translate }}</strong>
        <ion-text>{{
          (user?.lastLogin | date: 'M/d/yyyy' : 'GMT') || '-'
        }}</ion-text>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>
